import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import BankListUser from "../components/child/BankListUser";

const BankList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Danh sách ngân hàng" />
        <BankListUser />
      </MasterLayout>
    </>
  );
};

export default BankList;
